import React, { useState } from "react";

import { Responsive as ResponsiveGridLayout } from "react-grid-layout";

import { LoadingSlide } from "@components/title-slide-view";
import {
  BREAKPOINT_COLS,
  BREAKPOINT_WIDTHS,
} from "@features/overview-v2/constants";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { gridIsReady } from "@features/overview-v2/types";

import { Tile } from "../tile";

export const OverviewGrid = () => {
  const [resizingTile, setResizingTile] = useState<string | null>(null);

  const { tiles, updateTileLayout, grid, isMetadataLoading } =
    useOverviewContext();

  if (isMetadataLoading) {
    return <LoadingSlide />;
  }

  return (
    <div ref={grid.ref} className="relative">
      {gridIsReady(grid) && (
        <ResponsiveGridLayout
          className="layout"
          compactType="horizontal"
          margin={[0, 0]}
          containerPadding={[0, 0]}
          layouts={{ [grid.breakpoint]: grid.layouts }}
          breakpoints={BREAKPOINT_WIDTHS}
          onResizeStart={(_, oldItem) => setResizingTile(oldItem.i)}
          onResizeStop={(layouts) => {
            setResizingTile(null);
            updateTileLayout({ layouts });
          }}
          onDragStop={(layouts) => updateTileLayout({ layouts })}
          cols={BREAKPOINT_COLS}
          rowHeight={260}
          useCSSTransforms
          width={grid.width}
          resizeHandle={<div className="react-resizable-handle"></div>}
        >
          {tiles.map((tile) => (
            <Tile
              key={tile.id}
              tile={tile}
              isResizing={resizingTile === tile.id}
            />
          ))}
        </ResponsiveGridLayout>
      )}
    </div>
  );
};
